import { INITIALIZATION_ERROR, NAVIGATION, REDIRECTION } from './types';
const initialState = {
  location: '',
  previousLocation: '',
  query: {},
  queryString: '',
  redirection: '',
  data: {}
};
export const navReducer = (state = initialState, action) => {
  switch (action.type) {
    case NAVIGATION:
      return {
        ...state,
        previousLocation: state.location,
        location: action.context.canonicalPath.split('?')[0].replace(/\/$/, '').toLowerCase(),
        query: action.context.query || state.query,
        data: action.context.data
      };
    case REDIRECTION:
      return {
        ...state,
        redirection: action.redirect
      };
    case INITIALIZATION_ERROR:
      return {
        ...state,
        initErrorStatus: action.initErrorStatus,
        queryString: action.queryString || ''
      };
    default:
      return state;
  }
};